// extracted by mini-css-extract-plugin
export default {"ProductBox":"Product_ProductBox__8ypHJ","loader":"Product_loader__hnPIA","emptyPara":"Product_emptyPara__K8ek1","mainBox":"Product_mainBox__khRvh"};